var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserForbidden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_18384",
    "data-name": "Raggruppa 18384",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 33.653 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_6600",
    "data-name": "Rettangolo 6600",
    width: 33.653,
    height: 36,
    fill: "#a5a9c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18383",
    "data-name": "Raggruppa 18383",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23387",
    "data-name": "Tracciato 23387",
    d: "M66.791,19.348h0A9.675,9.675,0,1,0,66.806,0h-.022a9.661,9.661,0,0,0-6.836,16.5,9.619,9.619,0,0,0,6.844,2.846m0-16.643H66.8a6.969,6.969,0,1,1-.013,13.938H66.78A6.969,6.969,0,0,1,66.789,2.7",
    transform: "translate(-51.152 0.001)",
    fill: "#a5a9c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23388",
    "data-name": "Tracciato 23388",
    d: "M33.5,198.109a8.013,8.013,0,0,0-13.221-4.471.409.409,0,0,1-.425.1,18.3,18.3,0,0,0-7.628-.167,15.7,15.7,0,0,0-9.432,5.27,11.152,11.152,0,0,0-2.8,7.3,1.761,1.761,0,0,0,.25.892,1.258,1.258,0,0,0,1.078.582,1.337,1.337,0,0,0,.416-.066,1.385,1.385,0,0,0,.949-1.392,8.29,8.29,0,0,1,2.1-5.5c3.311-3.763,7.631-5.2,13.588-4.513l-.023.058c-.041.1-.074.188-.11.272a7.617,7.617,0,0,0-.571,4.062,8,8,0,0,0,9.261,6.966,8.075,8.075,0,0,0,6.565-9.4m-10.224,5.727c2.305-2.276,4.422-4.393,6.47-6.472a4.945,4.945,0,0,0,.419-.483,5.308,5.308,0,0,1-4.549,8.048h-.01a5.175,5.175,0,0,1-2.693-.768,4.88,4.88,0,0,0,.365-.325m4.491-8.3c-.743.736-1.493,1.488-2.219,2.215l-.967.968-.951.95c-.716.714-1.456,1.453-2.18,2.183-.137.138-.266.282-.385.429a5.283,5.283,0,0,1,4.544-7.974h.015a5.261,5.261,0,0,1,2.7.747,5.409,5.409,0,0,0-.556.482",
    transform: "translate(0 -171.617)",
    fill: "#a5a9c7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserForbidden);
export default __webpack_public_path__ + "static/media/user-forbidden.58f1d8b0.svg";
export { ForwardRef as ReactComponent };